import { render, staticRenderFns } from "./DispatchParkAppointLoad.vue?vue&type=template&id=a310d8c8&"
import script from "./DispatchParkAppointLoad.vue?vue&type=script&lang=js&"
export * from "./DispatchParkAppointLoad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports